import { createContext } from 'react';
import type { MutableRefObject } from 'react';

export const VideoTooltipContext = createContext<MutableRefObject<HTMLElement | null> | null | undefined | HTMLElement>(
  null,
);
